<template>
  <div class="uploadList">
    <div style="display: flex;flex-wrap: wrap; ">
      <el-table :data="table.data" border ref="mainTable" row-key="rowID">
        <el-table-column
          type="index"
          label="序号"
          width="50"
          fixed="left"
        ></el-table-column>
        <el-table-column prop="item_name" label="项目"></el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>
        <el-table-column :label="yearTitle[0]">
          <template v-slot="scope">
            <el-input
              v-model="scope.row.yearOne"
              @blur="handleBlue(scope.row.item_code, scope.row.yearOne)"
              style="width: 150px;"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="yearTitle[1]">
          <template v-slot="scope">
            <el-input
              v-model="scope.row.yearTwo"
              style="width: 150px;"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="yearTitle[2]">
          <template v-slot="scope">
            <el-input
              v-model="scope.row.yearThree"
              style="width: 150px;"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template v-slot="scope">
            <el-input
              v-model="scope.row.remark"
              style="width: 150px;"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      class="uploadBtn"
      v-if="this.form.opMode == 'edit'"
      style="margin-top: 5px; margin-bottom: 5px;"
    >
      <el-button type="primary" @click="_saveData">保存</el-button>
    </div>
  </div>
</template>

<script>
import ruiTool from "@/utils/ruiTool";
import {
  getApplyTableItem,
  getApplyTableData,
  postApplyTableData,
} from "@/api/modules/paTable";
import { vaildte } from "@/utils/validate";

export default {
  data() {
    return {
      form: {
        project_code: "",
        project_application_id: "",
        opMode: "",
      },
      table: {
        data: [],
      },
      /*近三年的年度标题*/
      yearTitle: [], //'2021', '2022', '2023'
    };
  },
  components: {},
  mounted() {
    //获取当前时间
    let myDate = new Date();
    //var curYear = parseInt(localStorage.getItem('project_year')) ;
    //this.yearTitle.push((curYear-2).toString(),(curYear-1).toString(),(curYear).toString());

    this.yearTitle.push("2023", "2024", "2025");

    //获取保存的传入参数
    this.form.project_application_id = localStorage.getItem("prjApplyCode");
    this.form.project_code = localStorage.getItem("prjCode");
    this.form.opMode = localStorage.getItem("opMode");

    if (ruiTool.isNull(this.form.project_application_id)) {
      //新增模式，只获取表格项目
      let paras = { project_type: localStorage.getItem("projectType") };
      getApplyTableItem({
        data: paras,
        success: (res) => {
          this.table.data = res.data.list;
        },
      });
    } else {
      //修改模式，通过项目申请编号获取表格项目和表格数据
      let paras = {
        prjApplyID: this.form.project_application_id,
        project_type: localStorage.getItem("projectType"),
      };
      getApplyTableData({
        data: paras,
        success: (res) => {
          this.table.data = res.data.list;
        },
      });
    }
  },
  methods: {
    /*年度列输出数据的检查*/
    handleBlue(code, value) {
      if (code != "14_10" && code != "15_10") {
        if (vaildte.isNum(value) == false) {
          this.$message.error("年度列必须填写数字,小数位最多2位");
        }
      }
    },
    /*检查数据录入*/
    checkInput(itemCodeList, yearOneList, yearTwoList, yearThreeList) {
      for (let i = 0; i < itemCodeList.length; i++) {
        //企业信用等级 无需检查
        if (itemCodeList[i] != "14_10" && itemCodeList[i] != "16_10") {
          if (vaildte.isNum(yearOneList[i]) == false) {
            this.$message.error("年度列必须填写数字,小数位最多2位");
            return false;
          }
          if (vaildte.isNum(yearTwoList[i]) == false) {
            this.$message.error("年度列必须填写数字,小数位最多2位");
            return false;
          }
          if (vaildte.isNum(yearThreeList[i]) == false) {
            this.$message.error("年度列必须填写数字,小数位最多2位");
            return false;
          }
        }
        //年度数据必填验证
        if (
          vaildte.isBlank(yearOneList[i]) ||
          vaildte.isBlank(yearTwoList[i]) ||
          vaildte.isBlank(yearThreeList[i])
        ) {
          this.$message.error("年度列必填");
          return false;
        }
      }
    },
    /*保存表格数据*/
    async _saveData() {
      this.form.project_application_id = localStorage.getItem("prjApplyCode");
      if (ruiTool.isNull(this.form.project_application_id)) {
        this.$message.error("请先提交基本信息");
        return;
      }
      //表格数据处理
      let itemCodeList = [];
      let yearOneList = [];
      let yearTwoList = [];
      let yearThreeList = [];
      let remarkList = [];
      for (let item of this.table.data.values()) {
        itemCodeList.push(item.item_code);
        yearOneList.push(item.yearOne);
        yearTwoList.push(item.yearTwo);
        yearThreeList.push(item.yearThree);
        remarkList.push(item.remark);
      }

      if (
        this.checkInput(
          itemCodeList,
          yearOneList,
          yearTwoList,
          yearThreeList
        ) == false
      )
        return;

      //数据提交
      const param = {
        prjApplyID: this.form.project_application_id,
        itemCodeList: itemCodeList,
        yearOneList: yearOneList,
        yearTwoList: yearTwoList,
        yearThreeList: yearThreeList,
        remarkList: remarkList,
      };
      await postApplyTableData({
        data: param,
        success: (res) => {
          this.$message({
            message: "保存成功",
            type: "success",
          });
        },
      });
    },
  },
};
</script>

<style scoped>
.uploadList {
  border: 0px solid #f0f0f0;
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 30px;
}
</style>
